/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Banner,
  Button,
  ButtonGroup,
  IndexTable,
  LegacyCard,
  Page,
  SkeletonDisplayText,
} from "@shopify/polaris";
import { AlertTriangleIcon } from "@shopify/polaris-icons";
import { useNavigate } from "react-router-dom";
import { useGetChildAccountsQuery } from "../store/store/slices/UsersRTK";
import { ChildAccountTypes } from "../store/types/types";
import UserTableRow from "../components/atoms/users/UserTableRow";
import RefreshButton from "../components/atoms/RefreshButton";
import GeneralPagination from "../components/atoms/Pagination";
import { useState } from "react";

export default function UsersTable() {
  const navigateTo = useNavigate();
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const params = new URLSearchParams(window.location.search);
  const {
    data: childAccounts,
    isLoading,
    isFetching,
    error,
    isError,
    refetch: refetchUsers,
  } = useGetChildAccountsQuery({
    page: params?.get("page") || "1",
    limit: params?.get("limit") || "50",
  });
  const paginationChangeHandler = (page: string, limit: string) => {
    params.set("page", page || "1");
    params.set("limit", limit || "1");
    navigateTo({ search: params.toString() });
  };

  if (isError) {
    return (
      <Page title="Users">
        <Banner icon={AlertTriangleIcon} tone="warning">
          {error?.data?.errors[0].msg}
        </Banner>
      </Page>
    );
  }
  return (
    <Page
      title="Users"
      fullWidth
      backAction={{
        onAction: () => {
          navigateTo(-1);
        },
      }}
      primaryAction={
        <ButtonGroup>
          <RefreshButton
            isLoading={isFetching}
            refetch={refetchUsers}
            tooltipContent="Refresh users"
          />
          <Button
            variant={theme === "dark" ? "secondary" : "primary"}
            onClick={() => {
              navigateTo("/dashboard/create-user");
            }}
          >
            Create user
          </Button>
        </ButtonGroup>
      }
    >
      <LegacyCard>
        <IndexTable
          loading={isLoading || isFetching}
          hasZebraStriping
          selectable={false}
          resourceName={{ singular: "user", plural: "users" }}
          itemCount={childAccounts?.childrenAccounts?.length || 0}
          headings={[
            { title: "Name" },
            { title: "Email" },
            { title: "Type" },
            { title: "Tag" },
            { title: "Scopes" },
            {
              title: "Status",
              tooltipContent: (
                <p style={{ textAlign: "center" }}>
                  Restrcited won't be able to login
                </p>
              ),
              flush: true,
              tooltipWidth: "wide",
            },
            {
              title: "Email verified",
              tooltipContent:
                "User won't be able to login with unverified email",
              alignment: "center",
            },
            { title: "Created" },
            { title: "Actions" },
          ]}
        >
          {childAccounts?.childrenAccounts?.map(
            (account: ChildAccountTypes, index: number) => (
              <UserTableRow key={index} account={account} index={index} />
            )
          )}
        </IndexTable>
      </LegacyCard>
      <div
        style={{ display: "flex", justifyContent: "center", padding: "2rem" }}
      >
        {!isLoading ? (
          <GeneralPagination
            currentPage={childAccounts?.pagination?.page}
            itemName="Users"
            limit={params?.get("limit") || "50"}
            onPageChange={paginationChangeHandler}
            total={childAccounts?.pagination?.total}
            totalPages={childAccounts?.pagination?.pages}
            key={"current"}
          />
        ) : (
          <div style={{ width: "300px" }}>
            <SkeletonDisplayText
              size="large"
              maxWidth="100%"
            ></SkeletonDisplayText>
          </div>
        )}
      </div>
    </Page>
  );
}
